import { supabase } from './supabase';

// El rastro de un intento de borrado que FALLÓ (mig 287).
//
// POR QUÉ ESTO VIVE EN EL CLIENTE
// -------------------------------
// El asiento del borrado bueno (`account_hard_deleted`) se escribe DENTRO de la
// transacción del borrado, así que si el borrado aborta, el asiento se va con
// él y «nunca se intentó» pasa a leerse igual que «se intentó y falló». Con el
// BUG 14 hubo que reproducir el fallo para saber cuál de las dos había sido.
//
// Dentro de Postgres no hay forma limpia de escribir una fila que sobreviva al
// rollback (se midió: `pg_net` encola en una tabla, `dblink` no está
// instalada, `NOTIFY` se entrega al commit). Quien sí sobrevive es el
// navegador: ya tiene el error en la mano. Así que la traza la deja el panel,
// en una segunda transacción, y la fila lo dice: `reported_by: 'panel'`.

/**
 * Deja constancia de un intento de borrado fallido.
 *
 * Devuelve si la traza llegó a escribirse. **No lanza nunca**: es una traza, y
 * hundir el diálogo por no poder dejarla sería peor que no dejarla.
 *
 * `event_type` lo fija el servidor: esta función no puede elegirlo.
 */
export async function registrarIntentoFallido(
  targetId: string,
  sqlstate: string | null,
  mensaje: string
): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('account_deletion_log_failure', {
      p_target: targetId,
      // El tipo generado no admite null en un parámetro con DEFAULT.
      p_sqlstate: sqlstate ?? undefined,
      p_message: mensaje.slice(0, 500),
    });

    // ⚠️ Se exige el ID DEVUELTO, y eso es MÁS fuerte que mirar el `error`:
    // PostgREST responde 204 aunque no se haya tocado ninguna fila, así que un
    // error ausente no prueba que la traza exista. Una traza muda es
    // exactamente el fallo que este diálogo vino a cerrar, una capa más arriba.
    //
    // El `error` se comprueba igualmente, y no por ceremonia: sin ligarlo, el
    // guard de lecturas mudas cuenta esta consulta como una de las suyas —lo
    // hizo— y un falso positivo en la lista base la va desgastando hasta que
    // deja de mirarse. Aquí además no cuesta nada: si hubo error, no hay traza.
    if (error) return false;
    return typeof data === 'string' && data.length > 0;
  } catch {
    return false;
  }
}
